import { useMutation, useQueryClient } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const placeOrder = (postData) => {
  return http().post(endpoints.quotes.placeOrder, postData)
};

export function usePostPlaceOrder() {
  const queryClient = useQueryClient();
  return useMutation(placeOrder, {
    onSuccess: () => {
      queryClient.invalidateQueries(["placeOrder"]);
    },
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
